import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExpertFile } from '@techspert-io/expert-files';
import {
  IExtendedTranscriptChunk,
  TranscriptService,
} from '@techspert-io/transcriptions';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileStoreService } from '../../../../../../shared/services/filestore.service';

export interface ITranscriptSeekTo {
  time: number;
}

export interface IExpertTranscriptDialogData {
  expertName: string;
  expertId: string;
  transcriptFile: ExpertFile;
  audioFile?: ExpertFile;
  expertActionId: string;
  seekTo?: ITranscriptSeekTo;
}

@Component({
  selector: 'app-expert-transcript-dialog',
  templateUrl: './expert-transcript-dialog.component.html',
  styleUrls: ['./expert-transcript-dialog.component.scss'],
  standalone: false,
})
export class ExpertTranscriptDialogComponent implements OnInit, OnDestroy {
  transcriptChunks$: Observable<IExtendedTranscriptChunk[]>;
  audioData?: string;
  audioStartTime = 0;

  private loadAudioCancel$ = new Subject<void>();

  get expertName(): string {
    return this.data.expertName;
  }

  get transcriptFile(): ExpertFile {
    return this.data.transcriptFile;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IExpertTranscriptDialogData,
    private transcriptService: TranscriptService,
    private fileStoreService: FileStoreService
  ) {}

  ngOnInit(): void {
    this.audioStartTime = this.data.seekTo?.time || 0;

    this.transcriptChunks$ = this.transcriptService.getTranscriptChunks(
      this.data.expertActionId
    );

    this.loadAudio();
  }

  ngOnDestroy(): void {
    this.loadAudioCancel$.next();
    this.loadAudioCancel$.complete();
    this.revokeAudioData();
  }

  private loadAudio(): void {
    if (!this.data.audioFile) {
      return;
    }

    this.loadAudioCancel$.next();

    this.fileStoreService
      .getExpertAudioFileContents(this.data.audioFile.fileKey)
      .pipe(takeUntil(this.loadAudioCancel$))
      .subscribe((audio) => {
        this.revokeAudioData();
        this.audioData = URL.createObjectURL(audio);
      });
  }

  private revokeAudioData(): void {
    if (this.audioData) {
      URL.revokeObjectURL(this.audioData);
      this.audioData = undefined;
    }
  }
}
